"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilters = exports.FiltersProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const filtersHelpers_1 = require("../../common/utils/filtersHelpers");
const FiltersContext = (0, react_1.createContext)(undefined);
const FiltersProvider = ({ children, }) => {
    const [filters, setFilters] = (0, react_1.useState)(filtersHelpers_1.getInitialFilters);
    (0, react_1.useEffect)(() => {
        localStorage.setItem('filters', JSON.stringify(filters));
    }, [filters]);
    return ((0, jsx_runtime_1.jsx)(FiltersContext.Provider, { value: { filters, setFilters }, children: children }));
};
exports.FiltersProvider = FiltersProvider;
const useFilters = () => {
    const context = (0, react_1.useContext)(FiltersContext);
    if (!context) {
        throw new Error('useFilters must be used within a FiltersProvider');
    }
    return context;
};
exports.useFilters = useFilters;
